import { call, fork, put, select, take } from "redux-saga/effects";
import { getType } from "typesafe-actions";
import { addCoins } from "../actions";
import { IApplicationState } from "../../index";
import { closeAds } from "../../advertisement/actions";
import { showAlert } from "../../dialog-manager/dialogs/showAlert";
import { AnyAction } from "redux";
import { closeDialog } from "../../dialog-manager/actions";
import i18n from "../../../shared/i18n";
import { showBonusAwardDialog } from "../../dialog-manager/dialogs/showBonusAwardDialog";
import { BonusType } from "../types";

export default function* watchAdForCoins() {
    while (true) {
        const { payload: { success } } = yield take((action: AnyAction) => {
            return action.type === getType(closeAds)
                && action.payload.adType === "rewarded"
                && action.payload.reward === "coins";
        });

        if (!success) {
            yield call(showAlert,
                i18n("gameplay.rewardedad.failed.header"),
                i18n("gameplay.rewardedad.failed.desc"));

            continue;
        }

        const { rewardedCoins } = yield select(({ settings }: IApplicationState) => settings.advertisement);

        yield fork(showBonusAwardDialog, { bonus: BonusType.Coins, count: rewardedCoins });
        yield take(closeDialog);
        yield put(addCoins(rewardedCoins, "watched_rewarded_ad_for_coins"));
    }
}
